import routes from 'components/lab/constants/routes'

/**
 * Buckets where the "Outsource Visibility" FILTER is offered (the row badge shows in
 * every bucket). On other buckets the filter param is also withheld from the request,
 * so a selection made here never silently filters an unsupported bucket.
 */
export const OUTSOURCE_VISIBILITY_BUCKETS = ['OPEN', 'DEMO_VER', 'INS_VER']

export const bucketColumnDefaults = {
  POXCOX: {
    RECENT: ['id', 'progress', 'messages', 'notes', 'updateDate'],
    [routes.order.pulseOxCapOx.directMessages.bucket]: [
      'id',
      'officeName',
      'progress',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.active.bucket]: [
      'id',
      'officeName',
      'progress',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.all.bucket]: [
      'id',
      'officeName',
      'progress',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.open.bucket]: [
      'id',
      'officeName',
      'progress',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.demographicVerification.bucket]: [
      'id',
      'officeName',
      'progress',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.failedFaxes.bucket]: [
      'select',
      'id',
      'faxUploadedDate',
      'physician',
      'faxNumber',
      'failureReason',
      'successfulFaxes',
      'faxAttempts',
      'lastFaxAttemptDate',
    ],
    [routes.order.pulseOxCapOx.pendingFaxes.bucket]: [
      'id',
      'officeName',
      'faxUploadedDate',
      'physician',
      'faxNumber',
      'faxAttempts',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.insuranceVerification.bucket]: [
      'id',
      'firstName',
      'lastName',
      'dob',
      'orderAge',
      'isOneShip',
      'primaryPayerId',
      'primaryPayer',
      'authorizationRequired',
      'primaryPayerStatus',
      'secondaryPayerId',
      'secondaryPayer',
      'secondaryPayerStatus',
      'payerFollowUpDate',
      'tertiaryPayer',
    ],
    [routes.order.pulseOxCapOx.needAttention.bucket]: [
      'id',
      'officeName',
      'progress',
      'tasks',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.awaitingReview.bucket]: [
      'id',
      'officeName',
      'progress',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.readyToSchedule.bucket]: [
      'id',
      'officeName',
      'progress',
      'followUpDate:HST',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.pendingReturn.bucket]: [
      'id',
      'deviceAssignedAt',
      'officeName',
      'progress',
      'followUpDate:HST',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.shippedBack.bucket]: [
      'id',
      'shippedBackAt',
      'officeName',
      'progress',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.deliveredBack.bucket]: [
      'id',
      'shippedBackAt',
      'officeName',
      'progress',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.followUp.bucket]: [
      'id',
      'officeName',
      'followUpDate:TPD',
      'progress',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.needToShip.bucket]: [
      'id',
      'officeName',
      'progress',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.readyToShip.bucket]: [
      'id',
      'officeName',
      'progress',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.shipped.bucket]: [
      'id',
      'officeName',
      'progress',
      'shippedAt',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.delivered.bucket]: [
      'id',
      'deviceAssignedAt',
      'officeName',
      'progress',
      'followUpDate:HST',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.completed.bucket]: [
      'id',
      'officeName',
      'progress',
      'messages',
      'notes',
      'completedAt',
      'updateDate',
    ],
    [routes.order.pulseOxCapOx.cancelled.bucket]: [
      'id',
      'officeName',
      'cancellationReason',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.billing.authorization.bucket]: [
      'id',
      'testType',
      'daysOfService',
      'orderCompletion',
      'primaryPayer',
      'secondaryPayer',
      'payerFollowUpDate',
      'payerNotes',
      'authorizationState',
      'updateDate',
    ],
    [routes.order.billing.billingReview.bucket]: [
      'select',
      'id',
      'testType',
      'daysOfService',
      'orderCompletion',
      'primaryPayer',
      'secondaryPayer',
      'faxedStatus',
      'payerNotes',
      'updateDate',
    ],
    [routes.order.billing.billingChargeBlocked.bucket]: [
      'select',
      'id',
      'testType',
      'daysOfService',
      'orderCompletion',
      'primaryPayer',
      'secondaryPayer',
      'faxedStatus',
      'payerNotes',
      'updateDate',
    ],
    [routes.order.billing.clientBillReview.bucket]: [
      'select',
      'id',
      'testType',
      'daysOfService',
      'orderCompletion',
      'primaryPayer',
      'secondaryPayer',
      'faxedStatus',
      'payerNotes',
      'updateDate',
    ],
    [routes.order.billing.billingHold.bucket]: [
      'id',
      'testType',
      'daysOfService',
      'orderCompletion',
      'primaryPayer',
      'secondaryPayer',
      'faxedStatus',
      'payerNotes',
    ],
    [routes.order.billing.billingFailed.bucket]: [
      'select',
      'id',
      'testType',
      'daysOfService',
      'orderCompletion',
      'primaryPayer',
      'secondaryPayer',
      'faxedStatus',
      'payerNotes',
    ],
    [routes.order.billing.billingQueued.bucket]: [
      'select',
      'id',
      'testType',
      'daysOfService',
      'orderCompletion',
      'primaryPayer',
      'secondaryPayer',
      'faxedStatus',
      'payerNotes',
    ],
    [routes.order.billing.billingPendingCharge.bucket]: [
      'id',
      'testType',
      'daysOfService',
      'orderCompletion',
      'primaryPayer',
      'secondaryPayer',
      'faxedStatus',
      'payerNotes',
    ],
    PATIENT_SMS: ['id', 'officeName', 'progress', 'smsMessages', 'notes', 'updateDate'],
  },
  HST: {
    [routes.order.hst.open.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'followUpDate:HST',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.awaitingReview.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.needAttention.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.orderVerification.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.demographicVerification.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.insuranceVerification.bucket]: [
      'id',
      'testType',
      'neededDeviceType',
      'firstName',
      'lastName',
      'dob',
      'orderAge',
      'isOneShip',
      'primaryPayerId',
      'primaryPayer',
      'authorizationRequired',
      'primaryPayerStatus',
      'secondaryPayerId',
      'secondaryPayer',
      'secondaryPayerStatus',
      'payerFollowUpDate',
      'tertiaryPayer',
    ],
    [routes.order.hst.paperworkVerification.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.pendingOfficeNotes.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.officeNotesVerification.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.patientConsent.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'followUpDate:HST_PATIENT_CONSENT',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.billing.billingReview.bucket]: [
      'select',
      'id',
      'testType',
      'daysOfService',
      'orderCompletion',
      'primaryPayer',
      'secondaryPayer',
      'faxedStatus',
      'payerNotes',
      'updateDate',
    ],
    [routes.order.billing.billingChargeBlocked.bucket]: [
      'select',
      'id',
      'testType',
      'daysOfService',
      'orderCompletion',
      'primaryPayer',
      'secondaryPayer',
      'faxedStatus',
      'payerNotes',
      'updateDate',
    ],
    [routes.order.billing.clientBillReview.bucket]: [
      'select',
      'id',
      'testType',
      'daysOfService',
      'orderCompletion',
      'primaryPayer',
      'secondaryPayer',
      'faxedStatus',
      'payerNotes',
      'updateDate',
    ],
    [routes.order.hst.preAuthorization.bucket]: [
      'id',
      'testType',
      'neededDeviceType',
      'daysOfService',
      'orderCompletion',
      'primaryPayer',
      'secondaryPayer',
      'payerFollowUpDate',
      'payerNotes',
      'authorizationState',
      'updateDate',
    ],
    [routes.order.hst.patientScheduling.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'followUpDate:HST_PAPERWORK',
      'authorizationValidTo',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.deviceShipping.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'deviceAssignedAt',
      'followUpDate:HST',
      'authorizationValidTo',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.patientTesting.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'deviceAssignedAt',
      'authorizationValidTo',
      'followUpDate:HST',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.pendingReport.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'authorizationValidTo',
      'reportPendingAt',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.wesperReview.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'authorizationValidTo',
      'reportPendingAt',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.retestPending.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'authorizationValidTo',
      'reportPendingAt',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.followUpCare.new.bucket]: [
      'id',
      'officeName',
      'referringProvider',
      'followUpCarePhysician',
      'followUpCareInitiatedAt',
      'notes',
    ],
    [routes.order.hst.followUpCare.sent.bucket]: [
      'id',
      'officeName',
      'referringProvider',
      'followUpCarePhysician',
      'followUpCareInitiatedAt',
      'notes',
    ],
    [routes.order.hst.followUpCare.confirmed.bucket]: [
      'id',
      'officeName',
      'referringProvider',
      'followUpCarePhysician',
      'followUpCareInitiatedAt',
      'notes',
    ],
    [routes.order.hst.completed.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'messages',
      'notes',
      'completedAt',
      'updateDate',
    ],
    [routes.order.hst.cancelled.bucket]: [
      'id',
      'officeName',
      'cancellationReason',
      'neededDeviceType',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.pendingFaxes.bucket]: [
      'id',
      'officeName',
      'neededDeviceType',
      'faxUploadedDate',
      'referringProvider',
      'faxNumber',
    ],
    [routes.order.hst.all.bucket]: [
      'id',
      'hstBucket',
      'officeName',
      'progress',
      'neededDeviceType',
      'authorizationValidTo',
      'followUpDate:HST',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.readyToSchedule.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.followUp.bucket]: [
      'id',
      'officeName',
      'followUpDateNo',
      'progress',
      'neededDeviceType',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.needToShip.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'deviceAssignedAt',
      'authorizationValidTo',
      'followUpDate:HST',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.readyToShip.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'deviceAssignedAt',
      'authorizationValidTo',
      'followUpDate:HST',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.shipped.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'deviceAssignedAt',
      'authorizationValidTo',
      'followUpDate:HST',
      'shippedAt',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.delivered.bucket]: [
      'id',
      'officeName',
      'authorizationValidTo',
      'followUpDate:HST',
      'progress',
      'neededDeviceType',
      'deviceAssignedAt',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.pendingReturn.bucket]: [
      'id',
      'officeName',
      'progress',
      'neededDeviceType',
      'deviceAssignedAt',
      'authorizationValidTo',
      'followUpDate:HST',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.shippedBack.bucket]: [
      'id',
      'shippedBackAt',
      'officeName',
      'progress',
      'neededDeviceType',
      'deviceAssignedAt',
      'authorizationValidTo',
      'followUpDate:HST',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.hst.deliveredBack.bucket]: [
      'id',
      'shippedBackAt',
      'officeName',
      'progress',
      'neededDeviceType',
      'deviceAssignedAt',
      'authorizationValidTo',
      'followUpDate:HST',
      'messages',
      'notes',
      'updateDate',
    ],
    PATIENT_SMS: ['id', 'officeName', 'progress', 'smsMessages', 'notes', 'updateDate'],
  },
  PSG: {
    [routes.order.psg.orderVerification.bucket]: [
      'id',
      'procedure',
      'officeName',
      'progress',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.psg.patientConsent.bucket]: [
      'id',
      'procedure',
      'officeName',
      'progress',
      'followUpDate:HST',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.psg.preAuthorization.bucket]: [
      'id',
      'procedure',
      'testType',
      'daysOfService',
      'orderCompletion',
      'primaryPayer',
      'secondaryPayer',
      'payerFollowUpDate',
      'payerNotes',
      'authorizationState',
    ],
    [routes.order.psg.patientScheduling.bucket]: [
      'id',
      'procedure',
      'officeName',
      'progress',
      'followUpDate:HST',
      'authorizationValidTo',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.psg.patientScheduled.bucket]: [
      'id',
      'procedure',
      'officeName',
      'progress',
      'inLabTestingScheduledAt',
      'authorizationValidTo',
      'followUpDate:HST',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.psg.followUpCare.new.bucket]: [
      'id',
      'officeName',
      'referringProvider',
      'followUpCarePhysician',
      'followUpCareInitiatedAt',
      'notes',
    ],
    [routes.order.psg.followUpCare.sent.bucket]: [
      'id',
      'officeName',
      'referringProvider',
      'followUpCarePhysician',
      'followUpCareInitiatedAt',
      'notes',
    ],
    [routes.order.psg.followUpCare.confirmed.bucket]: [
      'id',
      'officeName',
      'referringProvider',
      'followUpCarePhysician',
      'followUpCareInitiatedAt',
      'notes',
    ],
    [routes.order.psg.completed.bucket]: [
      'id',
      'procedure',
      'officeName',
      'progress',
      'messages',
      'notes',
      'completedAt',
      'updateDate',
    ],
    [routes.order.psg.cancelled.bucket]: [
      'id',
      'procedure',
      'officeName',
      'cancellationReason',
      'messages',
      'notes',
      'updateDate',
    ],
    [routes.order.psg.all.bucket]: [
      'id',
      'procedure',
      'hstBucket',
      'officeName',
      'progress',
      'authorizationValidTo',
      'followUpDate:HST',
      'messages',
      'notes',
      'updateDate',
    ],
    PATIENT_SMS: ['id', 'officeName', 'progress', 'smsMessages', 'notes', 'updateDate'],
  },
}

const bucketToFollowUpNamespace: Record<string, string> = {
  [routes.order.hst.patientConsent.bucket]: 'HST_PATIENT_CONSENT',
  [routes.order.hst.patientScheduling.bucket]: 'HST_PAPERWORK',
  [routes.order.pulseOxCapOx.readyToSchedule.bucket]: 'DEVICE',
  [routes.order.pulseOxCapOx.delivered.bucket]: 'DEVICE',
  [routes.order.pulseOxCapOx.pendingReturn.bucket]: 'DEVICE',
}

// HST shares the NO_NEW / NO_DELIVERED / PENDING_RETURN bucket strings with POX/COX,
// whose map entries above point at the POX 'DEVICE' namespace. HST device-lifecycle
// follow-ups live under 'HST', so resolve by test type before the map (TES-3011).
export const getFollowUpNamespace = (testType: string, bucket: string): string | undefined => {
  if (testType === 'HST') {
    if (bucket === routes.order.hst.pendingReturn.bucket) return 'HST'
    if (
      bucket === routes.order.hst.readyToSchedule.bucket ||
      bucket === routes.order.hst.delivered.bucket
    ) {
      return undefined
    }
  }
  return bucketToFollowUpNamespace[bucket]
}

const getTestTypeColumnKey = (testType: string) => {
  if (testType === 'HST') return 'HST'
  if (testType === 'PSG') return 'PSG'
  return 'POXCOX'
}

export type FollowUpFilterConfig = {
  showHumanFollowUpFilter: boolean
  followUpNamespace?: string
}

export const getFollowUpFilterConfig = (testType: string, bucket: string): FollowUpFilterConfig => {
  const columns = bucketColumnDefaults[getTestTypeColumnKey(testType)]?.[bucket] || []
  const followUpColumn = columns.find((col) => col.startsWith('followUpDate:'))

  if (!followUpColumn) {
    return { showHumanFollowUpFilter: false }
  }

  const columnNamespace = followUpColumn.split(':')[1]

  if (columnNamespace === 'HST') {
    const bucketNamespace = getFollowUpNamespace(testType, bucket)
    return bucketNamespace
      ? { showHumanFollowUpFilter: true, followUpNamespace: bucketNamespace }
      : { showHumanFollowUpFilter: true }
  }

  return { showHumanFollowUpFilter: true, followUpNamespace: columnNamespace }
}
